var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Aggregate",
    _vm._b(
      {
        attrs: {
          title: "Generators",
          ItemConstructor: _vm.generatorProjectFactory,
          headers: _vm.aggregateHeaders,
          cardProps: { flat: true, class: [] },
          "toolbar-dense": "",
        },
        on: {
          change: function ($event) {
            return _vm.$emit("change")
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item.active",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("v-switch", {
                    attrs: { dense: "" },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("change")
                      },
                    },
                    model: {
                      value: item.active,
                      callback: function ($$v) {
                        _vm.$set(item, "active", $$v)
                      },
                      expression: "item.active",
                    },
                  }),
                ]
              },
            },
            {
              key: "item.type",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("v-select", {
                    attrs: {
                      label: _vm.schema.type.title,
                      items: _vm.schema.type.enum,
                      "single-line": "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.changeItemType(item)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "selection",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " + _vm._s(_vm._f("titleCase")(data.item))
                              ),
                            ]
                          },
                        },
                        {
                          key: "item",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("titleCase")(data.item)) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: item.type,
                      callback: function ($$v) {
                        _vm.$set(item, "type", $$v)
                      },
                      expression: "item.type",
                    },
                  }),
                ]
              },
            },
            {
              key: "item.source",
              fn: function (ref) {
                var item = ref.item
                return [
                  item.type === "RENEWABLE"
                    ? _c("v-select", {
                        attrs: {
                          label: _vm.schema.source.title,
                          items: _vm.renewableSourceEnum,
                          "single-line": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " + _vm._s(_vm._f("titleCase")(data.item))
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("titleCase")(data.item)) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: item.source,
                          callback: function ($$v) {
                            _vm.$set(item, "source", $$v)
                          },
                          expression: "item.source",
                        },
                      })
                    : _vm._e(),
                  item.type === "THERMAL"
                    ? _c("v-select", {
                        attrs: {
                          label: _vm.schema.source.title,
                          items: _vm.thermalSourceEnum,
                          "single-line": "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " + _vm._s(_vm._f("titleCase")(data.item))
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("titleCase")(data.item)) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: item.source,
                          callback: function ($$v) {
                            _vm.$set(item, "source", $$v)
                          },
                          expression: "item.source",
                        },
                      })
                    : _vm._e(),
                ]
              },
            },
            {
              key: "item.capacity",
              fn: function (ref) {
                var item = ref.item
                return [
                  _vm._v(
                    " " +
                      _vm._s(
                        item.capacity[0] + " " + _vm.schema.capacity.unit
                      ) +
                      " "
                  ),
                ]
              },
            },
            {
              key: "default",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c(
                    "v-expand-transition",
                    [
                      _c(
                        "v-container",
                        { staticClass: "pa-4 cols" },
                        [
                          _c("InputGeo", {
                            attrs: {
                              label: "Coordinates",
                              "map-height": "150",
                              nullable: "",
                              "switch-text": "Use Generator coordinates",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: item.coordinates,
                              callback: function ($$v) {
                                _vm.$set(item, "coordinates", $$v)
                              },
                              expression: "item.coordinates",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              suffix: _vm.schema.start_year.unit,
                              label: _vm.schema.start_year.title,
                              hint: _vm.schema.start_year.tooltip,
                              type: "number",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: item.startYear,
                              callback: function ($$v) {
                                _vm.$set(item, "startYear", _vm._n($$v))
                              },
                              expression: "item.startYear",
                            },
                          }),
                          _c("InputYearlyProfile", {
                            attrs: {
                              label: _vm.schema.generation_profile.title,
                              suffix: _vm.schema.generation_profile.unit,
                              num_years: _vm.num_years,
                              "profile-type":
                                _vm.schema.generation_profile.profileType,
                              "multi-year-upload": true,
                              "object-value": "",
                              nullable: item.type === "THERMAL",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: item.generationProfile,
                              callback: function ($$v) {
                                _vm.$set(item, "generationProfile", $$v)
                              },
                              expression: "item.generationProfile",
                            },
                          }),
                          _c("InputYearly", {
                            attrs: {
                              label: _vm.schema.capacity.title,
                              suffix: _vm.schema.capacity.unit,
                              type: "number",
                              num_years: _vm.num_years,
                              year_start: _vm.year_start,
                              "spread-values": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: item.capacity,
                              callback: function ($$v) {
                                _vm.$set(item, "capacity", $$v)
                              },
                              expression: "item.capacity",
                            },
                          }),
                          _c("InputToggleParam", {
                            attrs: {
                              label:
                                _vm.schema.operating_status.properties.active
                                  .title,
                              hint: _vm.schema.operating_status.properties
                                .active.tooltip,
                              "error-messages": _vm.$utils.getIfExists(
                                _vm.errors,
                                ["operating_status"]
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var param = ref.param
                                    return [
                                      _c("InputProfile", {
                                        attrs: {
                                          hint: "Sets generator run mode (e.g., must-run, seasonal)",
                                          "profile-type":
                                            "DAILY_OPERATING_STATUS",
                                          "hide-divider": "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: param.id,
                                          callback: function ($$v) {
                                            _vm.$set(param, "id", $$v)
                                          },
                                          expression: "param.id",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: item.operating_status,
                              callback: function ($$v) {
                                _vm.$set(item, "operating_status", $$v)
                              },
                              expression: "item.operating_status",
                            },
                          }),
                          item.type === "THERMAL"
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "4" } },
                                    [
                                      _c(
                                        "v-switch",
                                        _vm._b(
                                          {
                                            attrs: {
                                              label:
                                                _vm.schema
                                                  .minimum_operating_load.title,
                                              hint: _vm.schema
                                                .minimum_operating_load.tooltip,
                                              "persistent-hint": "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value:
                                                item.minimum_operating_load
                                                  .active,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item.minimum_operating_load,
                                                  "active",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.minimum_operating_load.active",
                                            },
                                          },
                                          "v-switch",
                                          _vm.$attrs,
                                          false
                                        )
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-expand-transition",
                                    [
                                      item.minimum_operating_load.active
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12", sm: "8" } },
                                            [
                                              _c("InputYearly", {
                                                attrs: {
                                                  hint: _vm.schema
                                                    .minimum_operating_load
                                                    .description,
                                                  suffix:
                                                    _vm.schema
                                                      .minimum_operating_load
                                                      .unit,
                                                  "error-messages":
                                                    _vm.$utils.getIfExists(
                                                      _vm.errors,
                                                      ["value"]
                                                    ),
                                                  num_years: _vm.num_years,
                                                  fill: "",
                                                  "hide-divider": "",
                                                  "fill-value": 1,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.$emit("change")
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    item.minimum_operating_load
                                                      .value,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item.minimum_operating_load,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.minimum_operating_load.value",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.type === "RENEWABLE"
                            ? _c("InputYearly", {
                                attrs: {
                                  label:
                                    _vm.schema.curtailment_penalty_price.title,
                                  suffix:
                                    _vm.schema.curtailment_penalty_price.unit,
                                  type: "number",
                                  num_years: _vm.num_years,
                                  year_start: _vm.year_start,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.curtailmentPenaltyPrice,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      item,
                                      "curtailmentPenaltyPrice",
                                      $$v
                                    )
                                  },
                                  expression: "item.curtailmentPenaltyPrice",
                                },
                              })
                            : _vm._e(),
                          _c("InputYearly", {
                            attrs: {
                              label: _vm.schema.vom.title,
                              hint: "This parameter defines the variable costs for the unit",
                              suffix: _vm.schema.vom.unit,
                              type: "number",
                              num_years: _vm.num_years,
                              year_start: _vm.year_start,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: item.vom,
                              callback: function ($$v) {
                                _vm.$set(item, "vom", $$v)
                              },
                              expression: "item.vom",
                            },
                          }),
                          _c(
                            "v-expansion-panels",
                            { staticClass: "mb-4" },
                            [
                              _c(
                                "v-expansion-panel",
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(" Transient Stability Params "),
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    [
                                      _c("InputTextField", {
                                        attrs: {
                                          label: "Transient Ramp Rate",
                                          tooltip:
                                            "Maximum rate of power change during short-term system transitions",
                                          suffix: "MW/s",
                                          type: "number",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.transient_ramp_rate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "transient_ramp_rate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "item.transient_ramp_rate",
                                        },
                                      }),
                                      _c("InputYearly", {
                                        attrs: {
                                          label: "Inertia",
                                          hint: "Used for calculating inertia of system",
                                          suffix: "s",
                                          type: "number",
                                          num_years: _vm.num_years,
                                          year_start: _vm.year_start,
                                          fill: "",
                                          "fill-value": 0,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.inertia,
                                          callback: function ($$v) {
                                            _vm.$set(item, "inertia", $$v)
                                          },
                                          expression: "item.inertia",
                                        },
                                      }),
                                      _c("InputYearly", {
                                        attrs: {
                                          label: "Droop",
                                          hint: "Used for calculating droop of system",
                                          suffix: "%",
                                          type: "number",
                                          num_years: _vm.num_years,
                                          year_start: _vm.year_start,
                                          fill: "",
                                          "fill-value": 5,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit("change")
                                          },
                                        },
                                        model: {
                                          value: item.droop,
                                          callback: function ($$v) {
                                            _vm.$set(item, "droop", $$v)
                                          },
                                          expression: "item.droop",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-switch", {
                            attrs: {
                              label: _vm.schema.ppa.title,
                              hint: _vm.schema.ppa.tooltip,
                              "persistent-hint": "",
                              dense: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change")
                              },
                            },
                            model: {
                              value: item.ppa.active,
                              callback: function ($$v) {
                                _vm.$set(item.ppa, "active", $$v)
                              },
                              expression: "item.ppa.active",
                            },
                          }),
                          item.ppa.active
                            ? _c("InputYearlyProfile", {
                                attrs: {
                                  "object-value": "",
                                  fill: "",
                                  "toggle-items-type": "",
                                  label: _vm.schema.ppa.properties.energy.title,
                                  hint: _vm.schema.ppa.properties.energy
                                    .tooltip,
                                  suffix: "$/MWh",
                                  num_years: _vm.num_years,
                                  "profile-type":
                                    _vm.schema.ppa.properties.energy
                                      .profileType,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.ppa.energy,
                                  callback: function ($$v) {
                                    _vm.$set(item.ppa, "energy", $$v)
                                  },
                                  expression: "item.ppa.energy",
                                },
                              })
                            : _vm._e(),
                          item.ppa.active
                            ? _c("InputYearlyProfile", {
                                attrs: {
                                  "object-value": "",
                                  fill: "",
                                  "toggle-items-type": "",
                                  label:
                                    _vm.schema.ppa.properties.deemedEnergy
                                      .title,
                                  hint: _vm.schema.ppa.properties.deemedEnergy
                                    .tooltip,
                                  suffix: "$/MWh",
                                  num_years: _vm.num_years,
                                  "profile-type":
                                    _vm.schema.ppa.properties.deemedEnergy
                                      .profileType,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.ppa.deemedEnergy,
                                  callback: function ($$v) {
                                    _vm.$set(item.ppa, "deemedEnergy", $$v)
                                  },
                                  expression: "item.ppa.deemedEnergy",
                                },
                              })
                            : _vm._e(),
                          item.ppa.active
                            ? _c("InputYearlyProfile", {
                                attrs: {
                                  "object-value": "",
                                  fill: "",
                                  "toggle-items-type": "",
                                  label:
                                    _vm.schema.ppa.properties.capacity.title,
                                  hint: _vm.schema.ppa.properties.capacity
                                    .tooltip,
                                  suffix: "$/MW-month",
                                  num_years: _vm.num_years,
                                  "profile-type":
                                    _vm.schema.ppa.properties.capacity
                                      .profileType,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.ppa.capacity,
                                  callback: function ($$v) {
                                    _vm.$set(item.ppa, "capacity", $$v)
                                  },
                                  expression: "item.ppa.capacity",
                                },
                              })
                            : _vm._e(),
                          item.type === "THERMAL"
                            ? [
                                _c("InputTextField", {
                                  attrs: {
                                    label: _vm.schema.heatRate.title,
                                    tooltip: _vm.schema.heatRate.tooltip,
                                    suffix: _vm.schema.heatRate.unit,
                                    type: "number",
                                    min: _vm.schema.heatRate.minimum,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: item.heatRate,
                                    callback: function ($$v) {
                                      _vm.$set(item, "heatRate", $$v)
                                    },
                                    expression: "item.heatRate",
                                  },
                                }),
                                _c("InputServiceParam", {
                                  attrs: {
                                    "input-type": "dual-constant-profile",
                                    label: _vm.schema.carbonPrice.title,
                                    suffix: _vm.schema.carbonPrice.unit,
                                    num_years: _vm.num_years,
                                    "profile-type":
                                      _vm.schema.carbonPrice.profileType,
                                    year_start: _vm.year_start,
                                    "spread-values": "",
                                    "fill-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: item.carbonPrice,
                                    callback: function ($$v) {
                                      _vm.$set(item, "carbonPrice", $$v)
                                    },
                                    expression: "item.carbonPrice",
                                  },
                                }),
                                _c("InputTextField", {
                                  attrs: {
                                    label: _vm.schema.co2Rate.title,
                                    tooltip: _vm.schema.co2Rate.tooltip,
                                    suffix: _vm.schema.co2Rate.unit,
                                    type: "number",
                                    min: _vm.schema.co2Rate.minimum,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: item.co2Rate,
                                    callback: function ($$v) {
                                      _vm.$set(item, "co2Rate", $$v)
                                    },
                                    expression: "item.co2Rate",
                                  },
                                }),
                                _c("InputServiceParam", {
                                  attrs: {
                                    "input-type": "dual-constant-profile",
                                    label: _vm.schema.fuelPrice.title,
                                    suffix: _vm.schema.fuelPrice.unit,
                                    tooltip:
                                      "This parameter defines the fuel price for the unit and may be specified as either an annual constant or an hourly price profile",
                                    num_years: _vm.num_years,
                                    "profile-type":
                                      _vm.schema.fuelPrice.profileType,
                                    year_start: _vm.year_start,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$emit("change")
                                    },
                                  },
                                  model: {
                                    value: item.fuelPrice,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fuelPrice", $$v)
                                    },
                                    expression: "item.fuelPrice",
                                  },
                                }),
                                _c(
                                  "v-expansion-panels",
                                  { staticClass: "pa-2" },
                                  [
                                    _c(
                                      "v-expansion-panel",
                                      [
                                        _c(
                                          "v-expansion-panel-header",
                                          {
                                            staticClass:
                                              "text-subtitle-1 font-weight-medium",
                                          },
                                          [_vm._v("Services ")]
                                        ),
                                        _c(
                                          "v-expansion-panel-content",
                                          [
                                            _c("SystemProjectServices", {
                                              attrs: {
                                                "project-demands": _vm.demands,
                                                "project-reserves":
                                                  _vm.reserves,
                                                "project-generators":
                                                  _vm.generators,
                                                year_start: _vm.year_start,
                                                num_years: _vm.num_years,
                                                "services-schema":
                                                  _vm.thermalServicesSchema,
                                                "resource-type": "generator",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit("change")
                                                },
                                              },
                                              model: {
                                                value: item.services,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "services",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.services",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.computedValue,
          callback: function ($$v) {
            _vm.computedValue = $$v
          },
          expression: "computedValue",
        },
      },
      "Aggregate",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }